/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useState } from 'react';

import { redirectToRokidAccountCenter } from '@rokid/account';

import { GlobalLayoutAccountDropdown } from '@coze-foundation/layout';
import { useLogout } from '@coze-foundation/account-ui-adapter';
import { I18n } from '@coze-arch/i18n';
import { useUserInfo } from '@coze-arch/foundation-sdk';
import {
  IconCozExit,
  IconCozSetting,
  IconCozTeam,
  IconCozMore,
  IconCozChat,
  IconCozWechatFill,
  IconCozUserPermission,
} from '@coze-arch/coze-design/icons';
import { Dropdown, Typography, Image } from '@coze-arch/coze-design';

// import { UserInfoMenu } from './user-info-menu';
import { useAccountSettings } from './account-settings';
import { ContactUsMenu, useAuthUserinfoPluginModal } from './add-menus';
export { useAuthUserinfoPluginModal };
export const AccountDropdown = (props: { userInfo?: any }) => {
  const [visible, setVisible] = useState(false);
  const userInfo = props.userInfo || useUserInfo();
  const { node: logoutModal, open: openLogoutModal } = useLogout();
  const { modalContent: authUserInfoModal, open: openAuthUserinfoPluginModal } =
    useAuthUserinfoPluginModal({});

  const { node: accountSettingsNode, open: openAccountSettings } =
    useAccountSettings();

  if (!userInfo) {
    return null;
  }

  return (
    <GlobalLayoutAccountDropdown
      menus={[
        // <UserInfoMenu />,
        // <Dropdown.Divider />,
        // rokid 删除API相关
        // {
        //   prefixIcon: <IconCozExit />,
        //   title: I18n.t('settings_api_authorization'),
        //   onClick: () => {
        //     openAccountSettings('api-auth');
        //   },
        //   dataTestId: 'layout_avatar_api-auth',
        // },
        {
          type: 'packagingMenuItem',
          prefixIcon: <IconCozChat />,
          title: I18n.t('contact_us_contact_us'),
          dataTestId: 'layout_avatar_profile-contact-us',
          container: <ContactUsMenu />,
          extra: <IconCozMore />,
        },
        {
          type: 'menuItem',
          prefixIcon: <IconCozSetting />,
          title: I18n.t('navi_bar_account_settings'),
          onClick: () => {
            // rokid 跳转至账号中心
            // openAccountSettings('account');
            redirectToRokidAccountCenter();
          },
          dataTestId: 'layout_avatar_profile-settings',
        },
        {
          type: 'menuItem',
          prefixIcon: <IconCozUserPermission />,
          title: '授权管理',
          onClick: openAuthUserinfoPluginModal,
          dataTestId: 'layout_avatar_profile-settings',
        },
        { type: 'directReactNode', content: <Dropdown.Divider /> },
        {
          type: 'menuItem',
          prefixIcon: <IconCozExit />,
          title: I18n.t('basic_log_out'),
          onClick: () => {
            openLogoutModal();
          },
          dataTestId: 'layout_avatar_logout-button',
        },
      ]}
      visible={visible}
      onVisibleChange={setVisible}
      defaultUserInfo={userInfo}
    >
      {logoutModal}
      {accountSettingsNode}
      {authUserInfoModal}
    </GlobalLayoutAccountDropdown>
  );
};
